module.exports = __webpack_public_path__ + "static/media/lockbox.232aff9e.jpg";